<script setup lang="ts">
import { MContainerRow, MContainerSplit, MContainerColumn, MContainerGrow } from "@xlabmedical/medic-web-framework";

const { width } = useWindowSize();

const colCount = computed(() => (width.value > 1600 ? 3 : 2));
const buttonCount = computed(() => (width.value > 1600 ? 6 : 4));
</script>

<template>
    <div class="rounded border border-surface-900 px-6 pb-6 pt-2 bg-surface-0 dark:bg-surface-900" style="background: transparent; border-radius: 16px">
        <MContainerRow class="mt-4 gap-4">
            <MContainerSplit>
                <Skeleton :style="{ height: '28.5rem' }" borderRadius="16px" />
            </MContainerSplit>

            <MContainerSplit>
                <MContainerColumn class="w-full gap-6">
                    <!-- Header row -->
                    <MContainerRow>
                        <MContainerGrow>
                            <Skeleton width="8rem" height="4rem" borderRadius="16px" />
                        </MContainerGrow>
                        <Skeleton width="4rem" height="4rem" borderRadius="16px" />
                    </MContainerRow>

                    <!-- Two repeated rows, each with three columns -->
                    <MContainerRow v-for="row in 2" :key="'row-' + row">
                        <MContainerSplit v-for="col in colCount" :key="'col-' + row + '-' + col">
                            <MContainerColumn>
                                <Skeleton width="6rem" height="1.5rem" class="mb-2" borderRadius="16px" />
                                <Skeleton width="8rem" height="1.5rem" class="mb-2" borderRadius="16px" />
                            </MContainerColumn>
                        </MContainerSplit>
                    </MContainerRow>

                    <!-- Single row with one split -->
                    <MContainerRow>
                        <MContainerSplit>
                            <MContainerColumn>
                                <Skeleton width="9rem" height="1.5rem" class="mb-2" borderRadius="16px" />
                                <Skeleton width="8rem" height="1.5rem" class="mb-2" borderRadius="16px" />
                            </MContainerColumn>
                        </MContainerSplit>
                    </MContainerRow>

                    <!-- Icons row -->
                    <MContainerRow class="items-center justify-evenly">
                        <Skeleton v-for="i in buttonCount" :key="'icon-' + i" width="5rem" height="5rem" borderRadius="16px" />
                    </MContainerRow>
                </MContainerColumn>
            </MContainerSplit>
        </MContainerRow>
    </div>
</template>

<style scoped></style>
